<template>
  <div class="rollCallDetails">
    <div class="page_header">
      <div class="mwow-detail-header">
        <div class="left">
          <div class="back-btn" @click="$router.go(-1)">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
        </div>
        <div class="mid">
          <p>点名详情</p>
        </div>
        <div class="right">
          <div class="mwow-button success" @click="disabledClick('edit')">
            编辑
          </div>
          <div
            class="mwow-button warning del-rol-cal"
            @click="delRollCall(detailsData)"
            v-if="detailsData.status === 1"
          >
            撤销点名
          </div>
        </div>
      </div>
    </div>
    <el-row class="page_content">
      <el-col :span="24">
        <div>
          <div class="column">
            <span class="vertica weight">{{
              detailsData.class && detailsData.class.name
            }}</span>
            <div class="columnTabl">
              {{
                detailsData.class && detailsData.class.course_type == 1
                  ? "1vN"
                  : "1v1"
              }}
            </div>
            <span
              class="columnTabl class-type"
              v-if="detailsData.class.class_type === 1"
              >正课</span
            >
            <span
              class="columnTabl class-type"
              v-if="detailsData.class.class_type === 2"
              >体验</span
            >
            <span
              class="columnTabl class-type"
              v-if="detailsData.class.class_type === 3"
              >补课</span
            >
          </div>
        </div>
        <div>
          <el-col :span="8">
            <div>
              <div class="column">
                <span class="vertica weight smsize">班级课程：</span>
                <span class="vertica smsize">
                  {{ detailsData.course.title }}
                </span>
              </div>
              <div class="column">
                <span class="vertica weight smsize linefeed">授课教师：</span>
                <div style="width: 70%; text-align: left">
                  <span
                    class="vertica smsize"
                    v-for="(item, index) in detailsData.teacher_list"
                    :key="index"
                  >
                    {{
                      index != detailsData.teacher_list.length - 1
                        ? item.name + " , "
                        : item.name
                    }}
                  </span>
                  <span v-if="detailsData.teacher_list.length === 0">-</span>
                </div>
              </div>
              <div class="column">
                <span class="vertica weight smsize">授课模式：</span>
                <span class="vertica smsize">{{
                  detailsData.class_lesson.lesson_type == 1
                    ? "线下-门店授课"
                    : "线上-直播授课"
                }}</span>
              </div>
              <div class="column">
                <span class="vertica weight smsize">上课教室：</span>
                <span class="vertica smsize" v-if="detailsData.classroom">
                  {{ detailsData.classroom.name || "-" }}
                </span>
                <span class="vertica smsize" v-else>-</span>
              </div>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="column">
              <span class="vertica weight smsize right">上课时间：</span>
              <span class="vertica smsize"
                >{{ detailsData.lesson_date }} （周{{ detailsData.weekZh }}）
                {{ detailsData.class_lesson.start_time }} ~
                {{ detailsData.class_lesson.end_time }}
              </span>
            </div>
            <div class="column">
              <span class="vertica weight smsize right">排课课时：</span>
              <span class="vertica smsize">{{
                Number(detailsData.consume_number)
              }}</span>
            </div>
            <div class="column">
              <span class="vertica weight smsize right">点名状态：</span>
              <span class="vertica smsize">{{
                detailsData.status === 1 ? "正常" : "已撤销"
              }}</span>
            </div>
            <div class="column">
              <span class="vertica weight smsize right">点名学员：</span>
              <span class="smsize editBtn"
                >到课 {{ studentcount.attend_num }} 人</span
              >
              <span class="light"></span>
              <span class="smsize delBtn"
                >迟到 {{ studentcount.late_num }} 人</span
              >
              <span class="light"></span>
              <span class="smsize closeBtn"
                >请假 {{ studentcount.leave_num }} 人</span
              >
              <span class="light"></span>
              <span class="smsize latebtn"
                >未到课 {{ studentcount.absent_num }} 人</span
              >
            </div>
            <div class="contDixfl">
              <div class="vertica weight smsize right">上课内容：</div>
              <span
                class="vertica smsize"
                v-if="detailsData.class_lesson_extend.content"
                >{{ detailsData.class_lesson_extend.content }}</span
              >
              <span class="vertica smsize" v-else>-</span>
            </div>
          </el-col>
        </div>
      </el-col>
    </el-row>
    <div class="page_footer">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 学员名单 -->
        <el-tab-pane label="学员名单" name="studentlist" class="rollcall">
          <div class="btns">
            <!-- <student-dialog
              :studentType="1"
              :lessonData="detailsData"
              @change="updateList"
            >
              <div class="mwow-button-filled primary">添加临时学员</div>
            </student-dialog> -->
            <!-- <student-dialog
              :studentType="5"
              :lessonData="detailsData"
              @change="updateList"
            >
              <div class="mwow-button-filled inter">添加体验学员</div>
            </student-dialog> -->
          </div>
          <el-table
            size="mini"
            v-horizontal-scroll
            ref="multipleTable"
            tooltip-effect="dark"
            style="width: 100%"
            :data="tableData"
            stripe
          >
            <el-table-column label="学员姓名" prop="student.name">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.student"
                  style="display: flex; align-items: center"
                >
                  {{ scope.row.student.name || "-" }}
                  <span v-if="scope.row.student_type === 1" class="typelab"
                    >临时</span
                  >
                  <span v-if="scope.row.student_type === 5" class="typelabLearn"
                    >体验</span
                  >
                  <span
                    v-if="scope.row.student_type === 3"
                    class="make-up-lessson"
                  >
                    补课
                  </span>
                  <span
                    v-if="scope.row.student_type === 2"
                    class="make-up-lessson"
                  >
                    调课
                  </span>
                  <span
                    v-if="scope.row.is_del === 1"
                    class="mwow-tag del-filled large"
                    >已删除</span
                  >
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column label="签到状态" width="260">
              <template slot-scope="scope">
                <div class="checkinstatus" v-if="scope.row.sortBtn">
                  <div
                    :class="{ current: scope.row.student_status == 1 }"
                    @click="changeStudentStatus(scope.row, 1)"
                  >
                    到课
                  </div>
                  <div
                    :class="{ current: scope.row.student_status == 2 }"
                    @click="changeStudentStatus(scope.row, 2)"
                  >
                    迟到
                  </div>
                  <div
                    :class="{ current: scope.row.student_status == 3 }"
                    @click="changeStudentStatus(scope.row, 3)"
                  >
                    请假
                  </div>
                  <div
                    :class="{ current: scope.row.student_status == 4 }"
                    @click="changeStudentStatus(scope.row, 4)"
                  >
                    未到课
                  </div>
                </div>
                <div
                  v-else
                  :class="[
                    scope.row.student_status == 1
                      ? 'editBtn'
                      : scope.row.student_status == 2
                      ? 'delBtn'
                      : scope.row.student_status == 3
                      ? 'closeBtn'
                      : 'latebtn',
                  ]"
                >
                  {{ scope.row.student_statusName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="排课课程" prop="course.title">
              <template slot-scope="scope">
                <div v-if="scope.row.student_type == 5">-</div>
                <div v-else>
                  {{ scope.row.course && scope.row.course.title }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="耗课数">
              <template slot-scope="scope">
                <div v-if="scope.row.student_type != 5">
                  <!-- <div v-if="scope.row.sortBtn">
                    <el-input
                      :class="{ p2: scope.row.superupperColor }"
                      placeholder="请输入内容"
                      v-model="scope.row.consume_number"
                      @change="
                        () => {
                          scope.row.superupperColor = false;
                        }
                      "
                    ></el-input>
                  </div>
                  <div v-else>
                    {{ scope.row.consume_number }}
                    <span class="latebtn" v-if="scope.row.exceed_status == 2">
                      ( 超上{{ scope.row.exceed_number }}课时 )</span
                    >
                  </div> -->
                  <div v-if="scope.row.sortBtn">
                    <el-input
                      :class="{ p2: scope.row.superupperColor }"
                      placeholder="请输入内容"
                      v-model="scope.row.consume_number"
                      @change="
                        () => {
                          scope.row.superupperColor = false;
                        }
                      "
                    ></el-input>
                  </div>
                  <div v-else>
                    {{ scope.row.real_consume_number }}
                    <span class="latebtn" v-if="scope.row.exceed_status == 2">
                      ( 超上{{ scope.row.exceed_number }}课时 )</span
                    >
                  </div>
                </div>
                <div v-else>
                  <div class="closeBtn">体验学员不扣课时</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="课消金额">
              <template slot-scope="scope">
                <div>￥{{ scope.row.consume_amount }}</div>
              </template>
            </el-table-column>
            <el-table-column label="剩余课时" v-if="surplusCourse">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.usable_number ? scope.row.usable_number : "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="sheng">
              <template slot-scope="scope">
                <div v-if="scope.row.sortBtn">
                  <el-input
                    placeholder="请输入内容"
                    v-model.trim="scope.row.remark"
                    :class="{ inputColor: scope.row.borderColor }"
                    maxlength="255"
                    @change="
                      () => {
                        scope.row.borderColor = false;
                      }
                    "
                  ></el-input>
                </div>
                <div v-else>{{ scope.row.remark }}</div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.sortBtn" class="next_follow">
                  <div
                    class="mwow-button primary"
                    style="margin-right: 10px"
                    @click="lookDetails(scope.row, 'keep', scope.$index)"
                  >
                    保存
                  </div>
                  <div
                    class="mwow-button info"
                    @click="lookDetails(scope.row, 'close')"
                  >
                    取消
                  </div>
                </div>
                <div class="next_follow" v-else>
                  <div
                    class="mwow-button success"
                    style="margin-right: 10px"
                    @click="lookDetails(scope.row, 'edit', scope.$index)"
                  >
                    编辑
                  </div>
                  <detailsDialog :lessonData="scope.row">
                    <div class="mwow-button primary">查看</div>
                  </detailsDialog>
                  <div
                    class="mwow-button warning"
                    @click="lookDetails(scope.row, 'class')"
                    v-if="scope.row.exceed_status == 2"
                  >
                    扣课
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page="page"
            :page-size="pageSize"
            :page-sizes="pageSizeArray"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @current-change="handlePagerChange"
            @size-change="handlePagerSizeChange"
            :style="{ float: 'right', padding: '17px' }"
          >
          </el-pagination>
        </el-tab-pane>
        <!-- 学员名单END -->
        <!-- 修改记录 -->
        <el-tab-pane label="修改记录" name="modifyrecord">
          <el-table
            size="mini"
            ref="multipleTable"
            v-horizontal-scroll
            tooltip-effect="dark"
            style="width: 100%"
            :data="tableData"
            stripe
          >
            <el-table-column label="操作时间">
              <template slot-scope="scope">
                <div>{{ scope.row.create_time }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作人" prop="staff.name">
            </el-table-column>
            <el-table-column label="手机号" prop="staff.mobile">
            </el-table-column>
            <el-table-column label="操作类型" prop="codeName">
            </el-table-column>
            <el-table-column label="修改类型" prop="detail" width="700">
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page="page"
            :page-size="pageSize"
            :page-sizes="pageSizeArray"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @current-change="handlePagerChange"
            @size-change="handlePagerSizeChange"
            :style="{ float: 'right', padding: '17px' }"
          >
          </el-pagination>
        </el-tab-pane>
        <!-- 修改记录END -->
      </el-tabs>
    </div>
    <dialogCombox
      v-if="disabled"
      :type="types"
      :id="studentId"
      :itemData="dialogData"
      :student_ids="studentIdsList"
      @goBack="goBacks"
    ></dialogCombox>
  </div>
</template>
<script>
import { rollCallDetails } from "@/api/rollCallDetails";
import { dateFormat } from "@/utils/timeFormat";
import {
  rollCallListData,
  studentEdit,
  studentExceedHandle,
  exceedcode,
  courseAccount,
  lessonCancelRollCall,
} from "@/api/rollCallRecord";
import { rollCallStudentList } from "@/api/rollCall";
import { getstudentcount } from "@/api/studyDetails";
import { switchDetailApi } from "@/api/storeManagement";
import { getOperationLogInter, getOperationLogApi } from "@/api/store";
import dialogCombox from "./dialogCombox.vue";
import detailsDialog from "./detailsDialog.vue";
// import studentDialog from "./studentDialog.vue";
export default {
  components: {
    dialogCombox,
    // studentDialog,
    detailsDialog,
  },
  data() {
    return {
      activeName: "studentlist",
      surplusCourse: false, // 显示剩余课时
      courseNum: "", // 耗课数数
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 5,
      searchInfo: {},
      dialogVisible: false,
      followupList: [{ key: 1, value: "隐" }],
      dialogImageUrl: "",
      disabled: false,
      editbtn: true,
      detailsData: {
        class: {
          name: "",
        },
        course: {
          title: "",
        },
        teacher_list: [],
        class_lesson: {
          start_time: "",
          end_time: "",
        },
        class_lesson_extend: {
          content: "",
        },
      },
      id: 0,
      codeList: [],
      types: "",
      studentId: 0,
      dialogData: {
        lesson_date: "",
        lesson_start_time: "",
        lesson_end_time: "",
        consume_number: "",
        consume_class: "",
      },
      studentIdsList: [],
      studentcount: {},
      student_exceed: false,
    };
  },
  created() {
    this.init();
    switchDetailApi().then((res) => {
      if (res.error_code === 0) {
        this.student_exceed = res.data.student_exceed === 1;
      }
    });
  },
  methods: {
    updateList() {
      const _t = this;
      _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
    },
    init() {
      const _t = this;
      _t.id = Number(_t.$route.query.id);
      if (_t.id) {
        _t.getData(_t.id);
        _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
        _t.getexceedcode();
        _t.getstudentcountData();
      }
    },
    getstudentcountData() {
      const _t = this;
      const data = {};
      data.roll_call_id = _t.id;
      getstudentcount(data).then((res) => {
        if (res.error_code == 0) {
          _t.studentcount = res.data;
        }
      });
    },
    disabledClick(e) {
      const _t = this;
      _t.types = e;
      _t.studentId = _t.id;
      _t.dialogData.lesson_date = _t.detailsData.lesson_date;
      _t.dialogData.lesson_start_time = _t.detailsData.class_lesson.start_time;
      _t.dialogData.lesson_end_time = _t.detailsData.class_lesson.end_time;
      _t.dialogData.consume_number = _t.detailsData.consume_number;
      _t.dialogData.consume_class = _t.detailsData.class_lesson_extend.content;
      _t.disabled = true;
    },
    goBacks(e) {
      const _t = this;
      if (e == "edit") {
        _t.getData(_t.id);
      }
      _t.disabled = false;
    },
    getexceedcode() {
      const _t = this;
      exceedcode().then((res) => {
        if (res.error_code == 0) {
          _t.codeList = res.data.list;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    changeStudentStatus(e, type) {
      e.student_status = type;
    },
    lookDetails(e, type, ind) {
      const _t = this;
      if (type == "class") {
        studentExceedHandle({
          roll_call_student_id: e.roll_call_student_id,
        }).then((res) => {
          if (res.error_code == 0) {
            _t.$message({
              type: "success",
              message: "扣课成功",
            });
            _t.init();
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      } else if (type == "keep") {
        if (!this.student_exceed) {
          // 关闭超上的时候, 耗课数 > 总课时(剩余课时 + 上次消耗的课时)
          if (
            Number(e.consume_number) >
            Number(e.usable_number) + Number(this.courseNum)
          ) {
            _t.$message({
              type: "error",
              message: "耗课数不可超过剩余课时",
            });
            this.tableData[ind].superupperColor = true;
            return;
          }
        }
        if (e.student_type != 5) {
          if (!/^\d+(\.\d{1,2})?$/.test(e.consume_number)) {
            _t.$message({
              type: "error",
              message: "最多支持两位小数",
            });
            return;
          }
          if (e.consume_number == "" || e.consume_number < 0) {
            _t.$message({
              type: "error",
              message: "请正确输入耗课数",
            });
            return;
          }
        }
        if (e.remark.trim() == "") {
          _t.$message({
            type: "error",
            message: "请填写备注信息",
          });
          _t.tableData[ind].borderColor = true;
          return;
        }
        if (e.primeStatus != e.student_status) {
          _t.$confirm(
            `学员从"${
              ["到课", "迟到", "请假", "未到课"][e.primeStatus - 1]
            }"状态变为"${
              ["到课", "迟到", "请假", "未到课"][e.student_status - 1]
            }"状态，请确认实际耗课数是否正确！确定后修改签到状态。`,
            `签到状态变更`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              type: "warning",
            }
          )
            .then(() => {
              if (e.student_type != 5) {
                _t.postCourseAccount(e);
              } else {
                _t.clickrollcall(e);
              }
            })
            .catch(() => {});
        } else {
          if (e.student_type != 5) {
            _t.postCourseAccount(e);
          } else {
            _t.clickrollcall(e);
          }
        }
        this.surplusCourse = false;
      } else if (type == "close") {
        _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
        this.surplusCourse = false;
      } else if (type == "edit") {
        if (e.student_type !== 5) {
          courseAccount({
            student_id: e.student_id,
            course_id: e.course.course_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.surplusCourse = true;
              this.tableData[ind].usable_number =
                res.data.account.usable_number;
            }
          });
        }
        e.remark = e.remark == "-" ? "" : e.remark;
        e.sortBtn = true;
        e.primeStatus = e.student_status;
        this.courseNum = e.consume_number;
      }
    },
    postCourseAccount(e) {
      const _t = this;
      courseAccount({
        student_id: e.student_id,
        course_id: e.course.course_id,
      }).then((res) => {
        if (res.error_code == 0) {
          if (
            Number(e.consume_number) >
            Number(res.data.account.usable_number) + Number(this.courseNum)
          ) {
            _t.comfirClick(e);
          } else {
            _t.clickrollcall(e);
          }
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    clickrollcall(e) {
      const _t = this;
      studentEdit({
        roll_call_student_id: e.roll_call_student_id,
        student_status: e.student_status,
        consume_number: e.consume_number,
        remark: e.remark,
      }).then((res) => {
        if (res.error_code == 0) {
          _t.$message({
            type: "success",
            message: "修改成功",
          });
          _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    comfirClick(e) {
      const _t = this;
      _t.$confirm(
        "学员剩余课时不足，修改后会导致课时超上，请及时联系学员续费。",
        `超上 - ${e.course.title}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          _t.clickrollcall(e);
        })
        .catch(() => {});
    },
    getrollcallstudentlist(data) {
      const _t = this;
      data.roll_call_id = _t.id;
      rollCallStudentList(data).then((res) => {
        if (res.error_code == 0) {
          res.data.list.map((a) => {
            a.remark = a.remark == "" ? "-" : a.remark;
            a.sortBtn = false;
            switch (a.student_status) {
              case 1:
                a.student_statusName = "到课";
                break;
              case 2:
                a.student_statusName = "迟到";
                break;
              case 3:
                a.student_statusName = "请假";
                break;
              case 4:
                a.student_statusName = "未到课";
                break;
            }
          });
          res.data.list.map((item) => {
            item.borderColor = false;
            item.usable_number = 0;
            item.superupperColor = false;
          });
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    getData(id) {
      const _t = this;
      rollCallDetails({ roll_call_id: id }).then((res) => {
        if (res.error_code == 0) {
          const i = new Date(res.data.lesson_date.replace(/-/g, "/")).getDay();
          res.data.weekZh = ["日", "一", "二", "三", "四", "五", "六"][i];
          // res.data.class_lesson.start_time = res.data.class_lesson.start_time.slice(0, 5);
          // res.data.class_lesson.end_time = res.data.class_lesson.end_time.slice(0, 5);
          _t.detailsData = res.data;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    handleClick(tab, event) {
      const _t = this;
      _t.page = 1;
      _t.pageSize = 10;
      if (_t.id) {
        _t.getListData();
      }
    },
    getListData() {
      const _t = this;
      _t.tableData = [];
      switch (_t.activeName) {
        case "studentlist":
          _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
          break;
        case "modifyrecord":
          _t.getexceedHandle({
            page: _t.page,
            page_size: _t.pageSize,
          });
          break;
      }
    },
    getexceedHandle(parmas) {
      const _t = this;
      const number = [60000, 60001, 30515, 60002];
      parmas.page = 1;
      parmas.page_size = 1000;
      parmas.code = number;
      parmas.relation_id = _t.id;
      getOperationLogApi(parmas).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            res.data.list.map((a) => {
              _t.codeList.map((b) => {
                if (a.code == b.key) {
                  a.codeName = b.value;
                }
              });
              a.create_time = dateFormat(
                "YYYY年mm月dd日 HH时MM分",
                new Date(Number(a.create_time + "000"))
              );
            });
          }
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getListData();
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getListData();
    },
    // 撤销点名
    delRollCall(rollCallInfo) {
      this.$confirm(
        `撤销点名记录后，将退还未结课学员课时及金额，确定要撤销点名？`,
        `撤销点名 - ${rollCallInfo.class.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          lessonCancelRollCall({
            roll_call_id: rollCallInfo.roll_call_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                message: "撤销成功",
                type: "success",
              });
              this.$router.go(-1);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.rollCallDetails {
  .typelab,
  .typelabLearn {
    width: 30px;
    height: 14px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    background: #e2f1ff;
    font-size: 12px;
    margin-left: 5px;
  }
  .typelabLearn {
    color: #bf90ff;
    background: #eee4ff;
  }
  .make-up-lessson {
    text-align: center;
    line-height: 14px;
    display: inline-block;
    width: 30px;
    height: 14px;
    border-radius: 4px;
    color: #666666;
    background-color: #e4e4e4;
    margin-left: 5px;
  }
  // 弹框
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e7e8ea;
  }
  .btnsize {
    padding: 0 11px;
    line-height: 22px;
    margin-left: 10px;
  }
  .dialogForm {
    display: flex;
    justify-content: space-between;
  }
  .imageText {
    padding: 10px;
    border: 1px solid #e1e5e9;
    border-radius: 4px;
    textarea {
      height: 60px;
      width: 100%;
      resize: none;
      border: 0;
      outline: none;
    }
  }
  .next_follow {
    display: flex;
    .next_follow_left {
      width: 50%;
      height: 60px;
      display: flex;
      align-items: center;
    }
    .next_follow_right {
      width: 50%;
      height: 50px;
      padding-top: 10px;
      display: flex;
      justify-content: flex-end;
      span {
        color: rgba(7, 209, 170, 1);
      }
    }
  }
  /deep/ .el-upload_img {
    .el-upload {
      width: 80px;
      height: 80px;
      line-height: 95px;
    }
  }
  /deep/ .next_follow {
    .el-input__inner {
      height: 28px;
      line-height: 28px;
      width: 200px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .dialogCenter {
    overflow: hidden;
  }
  .checkinstatus {
    display: flex;
    div {
      width: 60px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      font-size: 12px;
      border: 1px solid #e7e8ea;
      margin-left: -1px;
      cursor: pointer;
    }
    div:nth-of-type(1) {
      border-radius: 4px 0 0 4px;
    }
    div:nth-of-type(4) {
      border-radius: 0 4px 4px 0;
    }
    div.current:nth-of-type(1) {
      background: #07d1aa;
      color: #fff;
    }
    div.current:nth-of-type(2) {
      background: #808080;
      color: #fff;
    }
    div.current:nth-of-type(3) {
      background: #ffb940;
      color: #fff;
    }
    div.current:nth-of-type(4) {
      background: #f56c6c;
      color: #fff;
    }
  }

  // 弹框end
  //页头
  .page_header {
    background: #fff;
    padding: 0 13px;
  }
  .page_header_left {
    display: flex;
    cursor: pointer;
    position: relative;
    align-items: center;
  }
  .el-icon-back {
    font-size: 18px;
    margin-right: 6px;
    align-self: center;
  }
  .el-icon-back:before {
    content: "\e6ea";
  }
  .page_header_left_back {
    font-size: 14px;
    font-weight: 500;
    margin-right: 40px;
    position: relative;
  }
  .page_header_left_back::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 16px;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #dcdfe6;
  }
  .page_header_content {
    font-size: 13px;
    font-weight: bold;
    color: #5c5d5e;
  }
  .page_header_control {
    display: flex;
    div:nth-of-type(2) {
      margin: 0 10px;
    }
  }
  //end
  .page_content {
    padding-top: 22px;
    background: #fff;
    padding: 13px;
    .page_content_avatar {
      border-radius: 50%;
      border: 1px solid #e7e8ea;
    }
    .column {
      display: flex;
      align-items: center;
      height: 35px;
      margin-bottom: 10px;
    }
    .vertica {
      font-size: 16px;
      color: #5c5d5e;
      min-width: 80px;
    }
    .weight {
      font-weight: bold;
    }
    .light {
      width: 1px;
      height: 16px;
      background-color: #dcdfe6;
      display: inline-block;
      margin: 0 10px;
    }
    .smsize {
      font-size: 14px;
    }
    .right {
      min-width: 25%;
      text-align: right;
    }
    .columnTabl {
      padding: 2px 7px;
      font-size: 8px;
      color: #409eff;
      border: 1px solid #409eff;
      border-radius: 4px;
      margin-left: 10px;
      line-height: normal;
    }
    .class-type {
      color: #5c5d5e !important;
      border: 1px solid #e7e8ea !important;
    }
    .linefeed {
      width: 71px;
    }
  }
  // end
  .page_footer {
    margin-top: 12px;
    min-height: 383px;
    background: #fff;
    padding: 0 13px 13px 13px;
    .footerTabs {
      border: none;
      padding: 0;
      .page_header_control {
        div {
          margin: 0;
          margin-left: 10px;
        }
      }
    }
    .page_header_content {
      color: #5c5d5e;
      font-size: 14px;
    }
    .purchased_details {
      font-size: 12px;
      color: #5c5d5e;
      display: flex;
      margin-top: 20px;
      .beleft {
        margin-right: 70px;
      }
      .notDue {
        margin-left: 18px;
        color: #07d1aa;
      }
      .purchased_class {
        display: flex;
        align-items: center;
      }
    }
    .purchasedLable {
      padding: 7px 15px;
      background: #f6fafc;
      color: #07d1aa;
      margin-right: 10px;
      display: flex;
      align-items: center;
    }
    .rollcall {
      .footerTabs {
        margin-bottom: 12px;
      }
      .purchasedLable {
        color: #5c5d5e;
        background: #fff7e9;
      }
    }
    .el-form .el-form-item__label {
      text-align: left !important;
    }
    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 12px !important;
      margin-right: 80px !important;
    }
    .becalled_header {
      display: flex;
      justify-content: center;
      align-items: center;
      .thisWeek {
        background: #f0fdfa;
        border: 1px solid #38dabb;
        height: 28px;
        width: 44px;
        color: #38dabb;
        border-radius: 4px;
        text-align: center;
        line-height: 28px;
        margin-right: 20px;
      }
      .week_date {
        font-size: 12px;
        color: #5c5d5e;
        margin: 0 20px;
      }
      .week_box {
        display: flex;
        justify-content: center;
        align-items: center;
        .week_box_left {
          width: 28px;
          height: 28px;
          opacity: 1;
          border: 1px solid #e7e8ea;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
    .question {
      width: 15px;
      height: 15px;
      opacity: 1;
      background: #bebfc0;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 16px;
      font-size: 10px;
      margin-left: 5px;
    }
    .followup {
      .footerTabs {
        margin-top: 3px;
        margin-bottom: 20px;
      }
    }
    .followupHead {
      opacity: 1;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      color: #5c5d5e;
      margin-top: 14px;
    }
    .followupCenter {
      padding: 0 19px;
      background: #f6fafc;
      margin-top: 14px;
    }
    .followupCenterHead {
      display: flex;
      justify-content: space-between;
      height: 44px;
      align-items: center;
    }
    .border {
      border-bottom: 1px solid #e7e8ea;
    }
    .followupCenterHead:last-child {
      margin-bottom: 0;
    }
    .followup_left_details {
      display: flex;
      align-items: center;
    }
    .followupCenter_left {
      display: flex;
      align-items: center;
      .followup_left_details {
        font-size: 12px;
        color: #5c5d5e;
        .followupName {
          font-weight: bold;
        }
      }
    }
    .followupCenter_right {
      display: flex;
      align-items: center;
      .light {
        margin: 0 10px;
      }
    }
    .light {
      width: 1px;
      height: 16px;
      background-color: #dcdfe6;
      display: inline-block;
      margin: 0 20px;
    }
  }
  .btns {
    margin-bottom: 10px;
    .container {
      margin: 0;
    }
    .mwow-button-filled {
      margin-left: 0px;
      margin-right: 10px;
    }
  }
  .FoUpBtn {
    color: #409eff;
  }
  .editBtn {
    color: #07d1aa;
  }
  .closeBtn {
    color: #ffb940;
  }
  .delBtn {
    color: #5c5d5e;
  }
  .latebtn {
    color: #f56c6c;
  }
}
/deep/.inputColor .el-input__inner {
  border-color: #ee111e;
}
.del-rol-cal {
  margin-left: 10px;
}
.contDixfl {
  display: flex;
  height: 35px;
  margin-bottom: 10px;
  .p1 {
    padding-left: -10px;
  }
  span {
    flex: 1;
  }
}
/deep/ .p2 {
  .el-input__inner {
    border-color: #ee111e;
  }
}
</style>
